import { Component, OnInit } from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { ActivatedRoute, Route, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CartService } from 'src/app/shared/services/e-commerce/cart.service';
import * as moment from 'moment'
@Component({
  selector: 'app-sales-detail',
  templateUrl: './sales-detail.component.html',
  styleUrls: ['./sales-detail.component.scss']
})
export class SalesDetailComponent implements OnInit {
  detailPayment: any = {};
  isLoading: boolean = true;
  productRefund: any;
  productsChange: any[] = [];
  quantityRefund: number = 1;
  indexItems: any;
  qtd: any[] = []
  productChange: any;
  productChangeId: any;
  tickets: number = 1;

  constructor(
    private afs: AngularFirestore,
    private actRouter: ActivatedRoute,
    private modalService: NgbModal,
    private router: Router,
    private cartService: CartService
  ) { }

  async ngOnInit() {
    this.detailPayment = {}
    this.isLoading = true;
    this.actRouter.params.subscribe(params => {
      this.afs.doc(`payments/${params.orderId}`)
        .get()
        .forEach(async (r: any) => {
          this.detailPayment = { id: r.id, ...r.data() }
          // const singleTotalRefund = this.detailPayment.items.reduce((acc, item) => {
          //   console.log(item);
          //   console.log(item.unitPrice);
          //   console.log(item.refund);
          //   console.log(item.discount);
          //   console.log('----');
          //   if (item.refund) {
          //     return acc + (item.unitPrice * (item.refund || 0) - (item.discount || 0))
          //   }
          //   else {
          //     return 0
          //   }
          // }, 0)


          // const variantTotalRefund = this.detailPayment.items.reduce((allTotal, product) => {
          //   const sum = product.variants.reduce((total, record) => {
          //     return total + (!!record.refund ? record.refund * record.price - (record.discountTotal || 0) : 0);
          //   }, 0);
          //   return allTotal + sum;
          // }, 0);
          // this.detailPayment.refundTotal = singleTotalRkefund
          // let totalRefund = 0;
          // this.detailPayment.items.map((item) => {
          //   if (!!item?.isRefund) {
          //     totalRefund += (item.unitPrice * (item.refund || 0) - (item.discount || 0))
          //   }
          // })
          // await this.afs.doc(`payments/${this.detailPayment.id}`).set({
          //   refundTotal: totalRefund
          // }, { merge: true })
        })
      this.isLoading = false
    });
    console.log(this.productsChange);

  }

  getTotalRefund() {
    const singleTotalRefund = this.detailPayment.items.reduce((acc, item) => {
      return acc + (item.refund || 0) * item.product.price
    }, 0)

    const variantTotalRefund = this.detailPayment.items.reduce((allTotal, product) => {
      const sum = product.variants.reduce((total, record) => {
        return total + (record.refund || 0) * record.price
      }, 0);
      return allTotal + sum;
    }, 0);

    return singleTotalRefund + variantTotalRefund
  }

  getTotal(prod) {
    if (prod.variants.length > 0) {
      const reducer = prod.variants.reduce((x, y) => x + (y.quantity * y.price), 0);
      return reducer
    } else {
      const total = prod.quantity * prod.product.price
      return total
    }
  }

  getQuantity(prod) {
    if (prod.variants.length > 0) {
      return prod.variants.reduce((x, y) => x + y.quantity, 0)
    } else {
      return prod.quantity
    }
  }

  getArray(obj) {
    return Object.assign([], obj)
  }

  error() {
    alert("Ocurrió un error inesperado, intente nuevamente")
  }

  openModal(content) {
    // this.productRefund = this.detailPayment.items[index]
    // this.indexItems = index;
    this.modalService.open(content, { size: 'lg' })
  }
  openModalChange(content, index = null) {
    // this.productChange = this.detailPayment.items[index]
    // this.productChangeId = this.detailPayment.id
    // this.indexItems = index;
    this.modalService.open(content, { size: 'lg' })
  }

  // refundProduct(product) {

  //   this.detailPayment.items[this.indexItems].refund = this.quantityRefund
  //   this.detailPayment.items[this.indexItems].isRefund = true
  //   this.detailPayment.items[this.indexItems].quantity = this.detailPayment.items[this.indexItems].quantity - this.quantityRefund;

  //   this.afs.doc(`payments/${this.detailPayment.id}`).set({
  //     ...this.detailPayment
  //   }, { merge: true })
  //     .then(() => {

  //       this.afs.doc(`products/${this.detailPayment.items[this.indexItems].product.id}`).get().forEach((re: any) => {
  //         const stock = re.data().stock;
  //         re.data().stock = stock + this.quantityRefund;
  //         this.afs.doc(re.ref.path).set({
  //           ...re.data()
  //         })
  //       })
  //     })
  //   this.modalService.dismissAll();
  //   window.location.reload();

  // }

  // refundVariant() {
  //   const cant = this.productRefund.variants.length;
  //   let errorFlag = false;
  //   for (let i = 0; i < cant; i++) {
  //     const element = document.getElementById("quantity-" + i) as HTMLInputElement | null;
  //     if (!!element) {
  //       if (parseInt(element.value) > this.productRefund.variants[i].quantity) {
  //         errorFlag = true;
  //       }
  //       if (parseInt(element.value) !== 0) {
  //         this.productRefund.variants[i].refund = parseInt(element.value);
  //         this.productRefund.variants[i].quantity = this.productRefund.variants[i].quantity - parseInt(element.value);
  //         this.productRefund.variants[i].isRefund = true;
  //       }
  //     }
  //   }
  //   if (errorFlag) {
  //     alert("Uno de los productos que intentas reembolsar, sobrepasa el total de productos permitidos")
  //     return;
  //   } else {
  //     this.detailPayment.items[this.indexItems] = this.productRefund;
  //     this.afs.doc(`payments/${this.detailPayment.id}`).set({
  //       ...this.detailPayment
  //     }, { merge: true })
  //     this.modalService.dismissAll()
  //     window.location.reload();
  //   }
  // }

  async refundVariant() {
    const cant = this.detailPayment.items.length;
    let errorFlag = false;
    let errorFlagVar = false;

    for (let i = 0; i < cant; i++) {
      if (this.detailPayment.items[i].variants.length === 0) {
        //SIMPLE
        const element = document.getElementById("quantitySimple-" + i) as HTMLInputElement | null;
        if (!!element) {
          if (parseInt(element.value) > this.detailPayment.items[i].quantity) {
            errorFlag = true;
          }
          if (parseInt(element.value) !== 0 && element.value !== "") {
            this.detailPayment.items[i].product.refund = parseInt(element.value);
            this.detailPayment.items[i].product.isRefund = true;
          }
        }
      } else {
        //VARIABLE
        this.detailPayment.items[i].variants.map((variant, ii) => {
          const elementVariant = document.getElementById("quantityVariant-" + ii) as HTMLInputElement | null;
          if (!!elementVariant) {
            if (parseInt(elementVariant.value) > this.detailPayment.items[i].variants[ii].quantity) {
              errorFlag = true;
            }
            if (parseInt(elementVariant.value) !== 0 && elementVariant.value !== "") {
              this.detailPayment.items[i].variants[ii].refund = parseInt(elementVariant.value);
              this.detailPayment.items[i].variants[ii].isRefund = true;
            }
          }
        })
      }
    }
    if (errorFlag || errorFlagVar) {
      alert("Uno de los productos que intentas reembolsar, sobrepasa el total de productos permitidos")
      return;
    } else {
      // this.detailPayment.items[this.indexItems] = this.productRefund;

      await this.afs.doc(`payments/${this.detailPayment.id}`).set({
        ...this.detailPayment
      }, { merge: true })
        .then(() => {
          //TODO: REPONER STOCK CUANDO SE REEMBOLSA

          // this.detailPayment.items.map((item, i) => {
          //   if (item.variants.length > 0) {
          //     //VARI
          //     item.variants.map((variant, ii) => {
          //       if (variant?.refund) {
          //         const pRef = this.afs.doc(`products/${item.product.id}`);
          //         pRef.get().forEach((r: any) => {
          //           const ind = r.data().variants.findIndex(v => v.variantName.toLowerCase() === variant.variantName.toLowerCase());
          //           
          //         })
          //       }
          //     })
          //   } else {
          //     //SING
          //   }
          // })
        })
      //TODO: DESCONTAR TODOS LOS PRODUCTOS REEMBOLSADOS

      // let totalRefund = 0;
      // this.detailPayment.items.map((item) => {
      //   if (!!item?.isRefund) {
      //     totalRefund += (item.unitPrice * (item.refund || 0) - (item.discount || 0))
      //   }
      // })
      // await this.afs.doc(`payments/${this.detailPayment.id}`).set({
      //   refundTotal: totalRefund
      // }, { merge: true })

      this.modalService.dismissAll()
      window.location.reload();
    }
  }

  getVariantRefund(prod) {
    if (prod.variants.length === 0) {
      return false;
    } else {
      return prod.variants.filter(v => v.refund).length > 0
    }
  }

  changeVariant(product) {
    const cant = this.productRefund.variants.length;
    let errorFlag = false;
    for (let i = 0; i < cant; i++) {
      const element = document.getElementById("quantityChange-" + i) as HTMLInputElement | null;
      if (!!element) {
        if (parseInt(element.value) > this.productRefund.variants[i].quantity) {
          errorFlag = true;
        }
        if (parseInt(element.value) !== 0) {
          if (errorFlag) {
            alert("Uno de los productos que intentas cambiar, sobrepasa el total de productos permitidos")
            return;
          } else {
            const product = this.productRefund.variants[i];
            product.change = parseInt(element.value);
            this.productsChange.push({ productName: this.productRefund.product.name, product });
          }
        }
      }
    }
    this.modalService.dismissAll()
  }

  changeSimple() {
    if (this.quantityRefund > this.detailPayment.items[this.indexItems].quantity) {
      alert("Uno de los productos que intentas cambiar, sobrepasa el total de productos permitidos")
      return
    } else {
      this.detailPayment.items[this.indexItems].product.change = this.quantityRefund
      const filter = this.productsChange.findIndex(p => p.product.id === this.detailPayment.items[this.indexItems].product.id)
      if (filter === -1) {
        this.productsChange.push(this.detailPayment.items[this.indexItems])
      } else {
        alert('Este producto ya está seleccionado para cambio')
      }
      this.modalService.dismissAll();
    }
  }

  async changeProducts() {
    localStorage.removeItem('cartItem');
    const cant = this.detailPayment.items.length;
    let errorFlag = false;
    let errorFlagVar = false;
    const cart = [];

    for (let i = 0; i < cant; i++) {
      if (this.detailPayment.items[i].variants.length === 0) {
        //SIMPLE
        const element = document.getElementById("quantityChangeSimple-" + i) as HTMLInputElement | null;
        debugger
        //TODO APLICAR LOGICA PARA LLAMAR A ADTOCARCHANGE
        if (!!element) {
          if (parseInt(element.value) > this.detailPayment.items[i].quantity) {
            errorFlag = true;
          }
          if (parseInt(element.value) !== 0 && element.value !== "") {
            this.detailPayment.items[i].product.change = parseInt(element.value);
            this.detailPayment.items[i].product.isChange = true;
            this.detailPayment.items[i].quantity = (parseInt(element.value) * -1)
            cart.push(this.detailPayment.items[i])
          }
        }
      } else {
        //VARIABLE
        this.detailPayment.items[i].variants.map((variant, ii) => {
          const elementVariant = document.getElementById("quantityChangeVariant-" + ii) as HTMLInputElement | null;
          debugger
          if (!!elementVariant) {
            if (parseInt(elementVariant.value) > this.detailPayment.items[i].variants[ii].quantity) {
              errorFlag = true;
            }
            if (parseInt(elementVariant.value) !== 0 && elementVariant.value !== "") {
              this.detailPayment.items[i].variants[ii].change = parseInt(elementVariant.value);
              this.detailPayment.items[i].variants[ii].isChange = true;
              this.detailPayment.items[i].variants[ii].quantity = parseInt(elementVariant.value) * -1
            } else {
              this.detailPayment.items[i].variants.splice(ii, 1)
            }
          }
        })
        cart.push(this.detailPayment.items[i]);
        localStorage.setItem('changeStatus', 'inProgress')
        localStorage.setItem('discountChange', this.getDiscount().toString())
      }
    }
    if (errorFlag || errorFlagVar) {
      alert("Uno de los productos que intentas reembolsar, sobrepasa el total de productos permitidos")
      return;
    } else {
      console.log(this.detailPayment)
      localStorage.setItem('cartItem', JSON.stringify(cart))
      await this.afs.doc(`payments/${this.detailPayment.id}`).set({
        ...this.detailPayment
      }, { merge: true })
        .then(() => {
          //TODO: REPONER STOCK CUANDO SE REEMBOLSA
        })

      // this.modalService.dismissAll()
      window.location.href = '/pos';
    }
  }

  getDiscount() {
    let discountTotal = 0;
    this.detailPayment.items.map((cart, idex) => {
      if (cart.variants.length > 0) {
        cart.variants.map((variant) => {
          discountTotal = discountTotal + (variant.discountTotal || 0)
        })
      } else {
        discountTotal = discountTotal + (cart.product.discountTotal || 0)
      }
    })
    return Math.round(discountTotal);
  }

  getToday() {
    return moment().format('DD-MM-YYYY')
  }

  printBill() {
    const printContent = document.getElementById("componentID");
    const WindowPrt = window.open('', '', 'left=0,top=0,width=900,height=900,toolbar=0,scrollbars=0,status=0');
    WindowPrt.document.write(printContent.innerHTML);
    WindowPrt.document.close();
    WindowPrt.focus();
    WindowPrt.print();
    WindowPrt.close();
  }

}
